import { render, staticRenderFns } from "./gantt.vue?vue&type=template&id=b476c39e&scoped=true&"
import script from "./gantt.vue?vue&type=script&lang=js&"
export * from "./gantt.vue?vue&type=script&lang=js&"
import style0 from "./gantt.vue?vue&type=style&index=0&id=b476c39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b476c39e",
  null
  
)

export default component.exports